import React, { useState } from 'react';

const LogoTile = ({ item }) => {
  const [failed, setFailed] = useState(false);
  const inner = (
    <div className="h-28 bg-white border border-gray-200 rounded-xl flex items-center justify-center px-6 hover:border-[#398024] hover:shadow-lg transition-all duration-300">
      {!failed && item.logo ? (
        <img
          src={item.logo}
          alt={`${item.name} logo`}
          width={160}
          height={80}
          loading="lazy"
          className="max-h-16 max-w-full object-contain"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="text-gray-700 font-semibold text-sm text-center">{item.name}</span>
      )}
    </div>
  );

  if (item.url) {
    return (
      <a href={item.url} target="_blank" rel="noopener noreferrer" aria-label={item.name}>
        {inner}
      </a>
    );
  }

  return inner;
};

const LogoGrid = ({ items, columns = 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4' }) => {
  return (
    <div className={`grid ${columns} gap-6`}>
      {items.map((item) => (
        <LogoTile key={item.name} item={item} />
      ))}
    </div>
  );
};

export default LogoGrid;
